import { z } from 'zod';
import {
  CloudAccountAutoScopeSchema,
  CloudAccountPolicyProviderSchema,
  CloudAccountPolicyStatusSchema,
} from './external-network.schema';

export const CloudInventorySurfaceAttachmentSchema = z.object({
  provider: CloudAccountPolicyProviderSchema,
  connected: z.boolean(),
  attached: z.boolean(),
  accountId: z.string().nullable(),
  accountRef: z.string().nullable(),
  displayName: z.string().nullable(),
  connectionId: z.string().nullable(),
  lastSyncedAt: z.coerce.date().nullable(),
  status: CloudAccountPolicyStatusSchema.nullable(),
  lastError: z.string().nullable(),
  enabled: z.boolean().nullable(),
  autoScope: CloudAccountAutoScopeSchema.nullable(),
});

export const ListCloudInventorySurfaceAttachmentsResponseSchema = z.object({
  attachments: z.array(CloudInventorySurfaceAttachmentSchema),
});

export const CloudInventorySurfaceProviderBodySchema = z.object({
  provider: CloudAccountPolicyProviderSchema,
  accountId: z.string().min(1).optional(),
  connectionId: z.string().min(1).optional(),
});

export const CloudInventorySurfaceAccountBodySchema =
  CloudInventorySurfaceProviderBodySchema.extend({
    accountId: z.string().min(1),
  });
